export default {"src":"/_next/static/media/no-record-found.652f3919.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};